import { z } from 'zod';

const AppConstants = z.object({
  OPM_COCKPIT_ENTRA_CLIENT_ID: z.string().optional(),
  OPM_COCKPIT_ENTRA_AUTHORITY: z.string().optional(),
  OPM_COCKPIT_LOCAL: z
    .string()
    .refine((value) => value === 'true' || value === 'false', {
      message: 'Value must be a boolean',
    })
    .transform((value) => value === 'true')
    .optional(),
  // Domain is not a url ;)
  OPM_COCKPIT_API_URL: z.url().optional(),
});

export type AppConstants = z.infer<typeof AppConstants>;

export function getAppConstants(): AppConstants {
  return AppConstants.parse(import.meta.env);
}
